import _ from 'lodash';
import { passPath } from '../../../utils/emmaUrlConverter';
import { goto } from '../../../actions/historyActions';
import { store } from '../../../stores';
import { resolveLocalizedText } from '../../../utils';
import { getErrorCodeConfig } from '../selectors/errorCodeSelectors';
import { contactPermissionPolicy } from '../types/changeContactService';

export const sortPermissionPolicies = (polices: contactPermissionPolicy[]) => {
  return [...polices].sort(
    (pA: contactPermissionPolicy, pB: contactPermissionPolicy) => {
      const entityCodeA = _.get(pA, 'entityCode', '');
      const entityCodeB = _.get(pB, 'entityCode', '');
      const resolvedPolicyNameA = resolveLocalizedText(pA.policyName || '');
      const resolvedPolicyNameB = resolveLocalizedText(pB.policyName || '');

      // sort by entityCode: EHK first, then LHK, then GHK
      if (entityCodeA !== entityCodeB) {
        const Ranks: { [key: string]: number } = {
          EHK: 1,
          LHK: 2,
          LMA: 2,
          GHK: 3,
        };
        const rankA = Ranks[entityCodeA] || 4;
        const rankB = Ranks[entityCodeB] || 4;

        return rankA - rankB;
      } else if (resolvedPolicyNameA !== resolvedPolicyNameB) {
        return resolvedPolicyNameA.localeCompare(
          resolveLocalizedText(resolvedPolicyNameB),
        );
      } else {
        return pA.policyNumber.localeCompare(pB.policyNumber);
      }
    },
  );
};

export const getErrorCode = (error: string, state: {}, feature_id?: string) => {
  const errorCodeConfig = getErrorCodeConfig(state);
  const codeMsg = _.get(errorCodeConfig, `${error}`, {});
  if (Array.isArray(codeMsg) && feature_id) {
    const returnCodeMsg = _.find(codeMsg, (item) => item.id == feature_id);
    return returnCodeMsg;
  }
  return codeMsg;
};

export const getErrorCodeFieldLabel = (errorCode: any, field: string) => {
  const fieldLabel = _.get(errorCode, `${field}`, {});
  return fieldLabel ? resolveLocalizedText(fieldLabel) : '';
};

export const callBackErrorCodePage = (id: string, errorCode: string) => {
  if (window && window.location.pathname.includes('/renewalupdate')) {
    goto(
      `emma-customer-profile-error-code-page-renewalupdate?feature_id=${id}&&error_code=${errorCode}`,
    );
  } else {
    goto(
      `emma-customer-profile-error-code-page?feature_id=${id}&&error_code=${errorCode}`,
    );
  }
};

export const returnErrorCode = (
  errorCode: string,
  defaultErrorCode: string,
  feature_id?: string,
) => {
  const codeMsg = getErrorCode(errorCode, store.getState(), feature_id);
  const returnErrorCode = _.isEmpty(codeMsg) ? defaultErrorCode : errorCode;
  return returnErrorCode;
};

export const returnAddressHorizontal = (address: any = {}) => {
  const addrLine1 = address.addrLine1 ? `${address.addrLine1} ` : '';
  const addrLine2 = address.addrLine2 ? `${address.addrLine2} ` : '';
  const addrLine3 = address.addrLine3 ? `${address.addrLine3} ` : '';
  return `${addrLine1}${addrLine2}${addrLine3}${address.addrLine4}`;
};

export const returnAddressVertical = (address: any = {}) => {
  const addrLine1 = address.addrLine1 ? `${address.addrLine1}<br/>` : '';
  const addrLine2 = address.addrLine2 ? `${address.addrLine2}<br/>` : '';
  const addrLine3 = address.addrLine3 ? `${address.addrLine3}<br/>` : '';
  return `${addrLine1}${addrLine2}${addrLine3}${address.addrLine4}${
    address.addrLine4 ? ' ' : ''
  }${address.districtAddress} ${address.country}`;
};
